import { Global, MantineTheme, MantineThemeOverride } from "@mantine/core";

export const GlobalStyle = () => {
  return (
    <Global
      styles={() => ({
        a: {
          color: "inherit",
          textDecoration: "inherit",
        },
      })}
    />
  );
};

export const themeConfig: MantineThemeOverride = {
  colors: {
    golomt: ["#d7f7f3", "#edd9f7", "#d8b1ea", "#3e166e", "#ae62d2", "#34105e", "#3e166e", "#3e166e", "#7b2aa0", "#6b218d"],
  },
  primaryColor: "golomt",
  components: {
    Breadcrumbs: {
      styles: (theme: MantineTheme) => ({
        breadcrumb: {
          color: theme.colors.gray[7],
          fontSize: 14,
        },
      }),
    },
  },
};
